




































import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import PointsTableRow from '@/components/delivery/delivery-points/PointsTableRow.vue'

@Component({
  components: { PointsTableRow },
})
export default class PointsTable extends Vue {
  @Prop(Array)
  points: DeliveryPoint[]

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'address',
      align: 'left',
      label: 'Адрес',
      field: 'address',
      sortable: true,
    },
    {
      name: 'cardEnabled',
      align: 'left',
      label: 'Оплата картой',
      field: 'cardEnabled',
      sortable: true,
    },
    {
      name: 'codEnabled',
      align: 'left',
      label: 'Оплата при получении',
      field: 'codEnabled',
      sortable: true,
    },
    {
      name: 'actions',
      align: 'right',
      label: '',
    },
  ]

  showNewForm() {
    this.$router.replace({ query: { create: '1' } })
  }
}
